import React from 'react';

const APIPerformancePanel = ({ apiData, loading }) => {
  if (loading) {
    return (
      <div className="bg-white rounded-lg shadow-lg p-6 animate-pulse">
        <div className="h-6 bg-gray-200 rounded w-1/3 mb-4"></div>
        <div className="space-y-3">
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
          <div className="h-4 bg-gray-200 rounded"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-xl font-bold text-gray-900">API Performance</h3>
        <span className="text-sm text-gray-500">
          {apiData?.timestamp ? new Date(apiData.timestamp).toLocaleTimeString() : 'Loading...'}
        </span>
      </div>

      <div className="space-y-6">
        {/* Key Metrics */}
        <div className="grid grid-cols-3 gap-3">
          <div className="text-center bg-blue-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-blue-600">
              {apiData?.total_requests_today?.toLocaleString() || 0}
            </div>
            <div className="text-xs text-gray-600">Requests Today</div>
          </div>
          <div className="text-center bg-green-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-green-600">
              {apiData?.average_response_time_ms || 0}ms
            </div>
            <div className="text-xs text-gray-600">Avg Response</div>
          </div>
          <div className="text-center bg-red-50 p-4 rounded-lg">
            <div className="text-2xl font-bold text-red-600">
              {apiData?.error_rate_percent?.toFixed(1) || '0.0'}%
            </div>
            <div className="text-xs text-gray-600">Error Rate</div>
          </div>
        </div>

        {/* Top Endpoints */}
        <div className="border-t pt-4">
          <div className="text-sm font-semibold text-gray-700 mb-3">Top Endpoints</div>
          <div className="space-y-2">
            {apiData?.top_endpoints && apiData.top_endpoints.slice(0, 5).map((endpoint, index) => (
              <div key={index} className="flex items-center justify-between p-2 bg-gray-50 rounded">
                <div className="flex-1">
                  <div className="text-sm font-mono text-gray-700 truncate">
                    {endpoint.endpoint}
                  </div>
                </div>
                <div className="ml-4 text-right">
                  <span className="text-sm font-semibold text-gray-900">
                    {endpoint.calls?.toLocaleString() || 0}
                  </span>
                  <span className="text-xs text-gray-500 ml-1">calls</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Performance Indicator */}
        <div className="border-t pt-4">
          <div className="flex items-center justify-between p-3 rounded-lg"
               style={{
                 backgroundColor: apiData?.error_rate_percent < 2 ? '#dcfce7' :
                                 apiData?.error_rate_percent < 5 ? '#fef3c7' : '#fee2e2'
               }}>
            <div className="flex items-center space-x-2">
              <span className="text-2xl">
                {apiData?.error_rate_percent < 2 ? '✓' :
                 apiData?.error_rate_percent < 5 ? '⚠' : '✗'}
              </span>
              <div>
                <div className="font-semibold text-gray-900">
                  {apiData?.error_rate_percent < 2 ? 'Excellent' :
                   apiData?.error_rate_percent < 5 ? 'Good' : 'Needs Attention'}
                </div>
                <div className="text-xs text-gray-600">API Health Status</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default APIPerformancePanel;

